<template>
    <a-card :bordered="false">
      <SignFileShow :bidProjectId='bidProjectId' type='planSubmit' ></SignFileShow>
      <a-divider orientation="left" style="margin-top: -5px;">
        已提交的文件
      </a-divider>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="fileColumns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"

      >
        <span slot="action" slot-scope="text, record">
              <a @click="handleDownload(record)">下载</a>
        </span>
      </a-table>
      <div v-show='roleCode == "trading_center"' style="margin-top: 10px;text-align: center">
        <a-button htmlType='button' @click='handleSubmit($event,1)' type='primary' :loading='loading'>通过
        </a-button>
        <span >
            <a-button htmlType='button' style='margin-left: 8px' @click='handleSubmit($event,0)'
                      :loading='loading'>审核不通过</a-button>
        </span>
      </div>
    </a-card>
</template>

<script>
  import { getAction, postAction,downloadFile } from '@/api/manage'
  import {folderDefine} from '@constant/folder'
  import SignFileShow from '@views/bobidopen/modules/SignFileShow'
  import {mapGetters} from "vuex";

  export default {
    components: {
      SignFileShow,
    },
    name: "PersonPlanExamine",
    inject: ['closeCurrent'],
    data () {
      return {
        tenderProjectInfo : {},
        projectInfo: {},
        folderDefine : folderDefine,
        url: {
          list: "/ebid-ce/file/list",
          minioDownload: "/ebid-ce/file/minioDownload",
        },
        loading: false,
        fileColumns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '文件名称',
            align: "center",
            dataIndex: 'fileName'
          },
          {
            title: '文件类型',
            align: "center",
            dataIndex: 'typeZh'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
        queryParam: {},
        dataSource:[],
        bidProjectId:'',
      }
    },
    created(){
      this.bidProjectId = this.$route.query.id
      this.setBidProjectId(this.bidProjectId)
    },
    computed: {
      ...mapGetters(['username', 'nickname', 'userInfo']),
      roleCode: function() {
        return this.userInfo.roleCode
      }
    },
    methods: {
      setBidProjectId(id) {
        //1.根据招标编号ID获取招标项目信息和项目信息
        getAction("/ebid-ce/tmBidProject/queryById",{id:this.bidProjectId}).then(res=>{
          if(res.success){
            this.tenderProjectInfo = res.result;
            let projectId = this.tenderProjectInfo.projectId;
            //2.查询项目信息
            getAction("/ebid-ce/tmProject/queryById",{id:projectId}).then(res=>{
              if(res.success){
                this.projectInfo = res.result;
              }else {

              }
            })
          }else {

          }
          this.queryParam.bidId = id;
          this.loadData();
        })
      },
      //查询已提交文件信息
      loadData(arg) {
        if(!this.url.list){
          //this.$message.error("请设置url.list属性!")
          return
        }
        this.queryParam.type = 'personPlanAnnex';
        var params = this.queryParam;//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            let list = res.result.records||res.result;
            this.dataSource = list;
            //此处是为了附件显示的是最新上传的一份
            this.dataSource.splice(1,this.dataSource.length-1)
          }
          this.loading = false;
        })
      },
      handleDownload(rec) {
        var that = this;
        getAction(that.url.minioDownload,{id: rec.id}).then(res => {
          if(res.success) {
            // downloadFile(res.result , rec.fileName);
            window.open(res.result,'_blank');
          }else{
            that.$message.error(res.message);
          }
        })
      },
      handleSubmit(e, statusCode) {
        if (!statusCode) {
          const that = this
          that.$confirm({
            title: '提示',
            content: '是否确认审核不通过?',
            onOk() {
              that.loading = true
              let params = {}
              params.wfInsId = that.$route.query.processInstanceId
              params.bidProjectId = that.bidProjectId
              params.checkStatus = '2'
              postAction('/ebid-ce/tmBidPlan/examinePersonPlanTask',params).then((res) => {
                if (res.success) {
                  that.changeIsResult(true)
                }
              }).finally(() => {
                that.loading = false
              })
            },
            onCancel() {
            }
          })
        } else {
          const that = this
          this.$confirm({
            title: '提示',
            content: '是否确认提交?',
            onOk() {
              that.loading = true
              let params = {}
              params.bidProjectId = that.bidProjectId
              params.wfInsId = that.$route.query.processInstanceId
              params.checkStatus = '1'
              postAction('/ebid-ce/tmBidPlan/examinePersonPlanTask',params).then((res) => {
                if (res.success){
                  that.changeIsResult(true)
                }
              }).finally(() => {
                that.loading = false
              })
            },
            onCancel() {
            }
          })
        }
      },
      changeIsResult(val) {
        if (val) {
          let that = this
          that.$message.success('审核成功!', 1, function() {
            that.closeCurrent()
          })
        }
      },
    }
  }
</script>

<style lang="less" scoped>

</style>